import React from "react";
import * as react from "react";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { IconButton } from "@mui/material";
import { defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { singleton, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";

export function Components_CollapseChevronButton_5E9F1DB5(components_CollapseChevronButton_5E9F1DB5InputProps) {
    let elements;
    const disabled = components_CollapseChevronButton_5E9F1DB5InputProps.disabled;
    const onClick = components_CollapseChevronButton_5E9F1DB5InputProps.onClick;
    const isOpen = components_CollapseChevronButton_5E9F1DB5InputProps.isOpen;
    return MuiHelpers_createElement(IconButton, [["onClick", (_arg) => {
        onClick();
    }], ["size", "small"], ["disabled", defaultArg(disabled, false)], (elements = toList(delay(() => {
        let props_1, props_3;
        return isOpen ? singleton((props_1 = {}, react.createElement(ExpandMore, props_1))) : singleton((props_3 = {}, react.createElement(ChevronRight, props_3)));
    })), ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

